import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {PaginatedEnsueCollection} from "../../../../../ensue-react-system/utilities/paginated-ensue-collection";
import {StatusEnum} from "../../../../../commons/enums/status-enum";
import {MatchStatusEnum} from "../../../../../commons/enums/match-status-enum";
import {manageFootballTeamService} from "../../../../../commons";
import {FootballMatchDetail} from "../../../../../commons/models/football/football-match-detail";

export interface IFootballManageTeamMatchOption {
    teamId: number;
    urlParams?: {
        hostTeamId?:number;
        page?: number;
        perPage?: number;
        sort?: string;
        sortOrder?: string;
        competitionId?: number;
        seasonId?: number;
        status?: MatchStatusEnum;
        afterDate?: string;
        beforeDate?: string;
    };
}

interface IMatchStore {
    matchList: PaginatedEnsueCollection<FootballMatchDetail>;
    liveMatches: PaginatedEnsueCollection<FootballMatchDetail>;
    upcomingMatches: PaginatedEnsueCollection<FootballMatchDetail>;
    finishedMatches: PaginatedEnsueCollection<FootballMatchDetail>;
    matchStatus?: StatusEnum;
    error?: string | null;
}

const initialState: IMatchStore = {
    matchList: new PaginatedEnsueCollection<FootballMatchDetail>(),
    liveMatches: new PaginatedEnsueCollection<FootballMatchDetail>(),
    upcomingMatches: new PaginatedEnsueCollection<FootballMatchDetail>(),
    finishedMatches: new PaginatedEnsueCollection<FootballMatchDetail>(),
    matchStatus: StatusEnum.Idle,
};

const footballManageTeamMatchListSlice = createSlice({
        name: "manage-team-match-list",
        initialState: initialState,
        reducers: {
            cleanUpManageTeamMatchList(state) {
                state.matchList = new PaginatedEnsueCollection<FootballMatchDetail>();
                state.upcomingMatches = new PaginatedEnsueCollection<FootballMatchDetail>();
                state.liveMatches = new PaginatedEnsueCollection<FootballMatchDetail>();
                state.finishedMatches = new PaginatedEnsueCollection<FootballMatchDetail>();
                state.matchStatus = StatusEnum.Idle;
            },
        },
        extraReducers(builder) {
            builder
                .addCase(fetchManageTeamMatchList.pending, (state) => {
                    state.matchStatus = StatusEnum.Loading;
                })
                .addCase(fetchManageTeamMatchList.fulfilled, (state, action) => {
                    state.matchStatus = StatusEnum.Succeeded;
                    state.matchList = action.payload as PaginatedEnsueCollection<FootballMatchDetail>;
                    state.liveMatches = state.matchList.where(match=> match.status === MatchStatusEnum.Live) as PaginatedEnsueCollection<FootballMatchDetail>;
                    state.upcomingMatches = state.matchList.where(match=> match.status === MatchStatusEnum.Upcoming) as PaginatedEnsueCollection<FootballMatchDetail>;
                    state.finishedMatches = state.matchList.where(match=> match.status === MatchStatusEnum.Finished) as PaginatedEnsueCollection<FootballMatchDetail>;
                })
                .addCase(fetchManageTeamMatchList.rejected, (state) => {
                    state.matchStatus = StatusEnum.Failed;
                })
        }
        ,
    })
;

export const fetchManageTeamMatchList = createAsyncThunk(
    "matches/fetchManageTeamMatchList",
    async (options: IFootballManageTeamMatchOption, thunkAPI) => {
        try {
            const matchList = await manageFootballTeamService.getTeamMatches(options.teamId, options.urlParams);
            return matchList.map(item => ({...item, competitionId: item.competition?.id}));
        } catch (e) {
            return thunkAPI.rejectWithValue(e);
        }
    }
);

export const {cleanUpManageTeamMatchList} = footballManageTeamMatchListSlice.actions;
export default footballManageTeamMatchListSlice.reducer;